import { app } from '../../../../../app';
import { Controller } from './approval-policies-list.controller';

app.component('requestCenterPoliciesList', {
    bindings: {
        policies: '<',
        defaultPolicy: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./approval-policies-list.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/policies/list/approval-policies-list.component.js